import React from 'react';
interface PhoneFrameProps {
  children: React.ReactNode;
}

/** Mobile-first preview shell for the teaser. */
export function PhoneFrame({
  children
}: PhoneFrameProps) {
  return <div className="flex min-h-screen w-full flex-col items-center justify-center bg-gray-200 px-4 py-8" data-id="element-52" data-mp="1xuft2w3hkx38">
      <div className="relative flex h-[844px] w-[390px] flex-col overflow-hidden rounded-[3rem] border-[10px] border-gray-800 bg-solventum-bg shadow-2xl" data-id="element-53" data-mp="22kmigy5tolmj">
        <div className="absolute inset-x-0 top-0 z-30 flex h-7 justify-center bg-solventum-bg" data-id="element-54" data-mp="27jpnwjppstv1">
          <div className="h-5 w-28 rounded-b-2xl bg-gray-800" data-id="element-55" data-mp="2bjre9wq020v0" />
        </div>
        <div className="absolute inset-x-0 bottom-1.5 z-30 flex justify-center" data-id="element-56" data-mp="2glyw32xigb59">
          <div className="h-1 w-32 rounded-full bg-white/20" data-id="element-57" data-mp="2lk0fjoyumch9" />
        </div>
        <div className="mt-6 flex-1 overflow-hidden" data-id="element-58" data-mp="m6w8jas0v34z">{children}</div>
      </div>
    </div>;
}